import React from "react";
import "../WhyChooseUs/WhyChooseUs.css";
import quality from "../Assets/quality.png";
import clock from "../Assets/clock.png";
import expert from "../Assets/expert.png";
import data from "../Assets/oracle-data-integrator.png";
import { motion } from "framer-motion";

function WhyChooseUs() {
  return (
    <>
      <motion.div initial={{ opacity:0  }} transition={{ ease: "easeIn", duration: 3 }} whileInView={{ opacity:1 }} className="whyChooseUs">
        <h2>
          Why people choose us
          <hr />
        </h2>

        <div className="whyChooseUs-container">
          <div className="whyChooseUs-container-div1">
            <ul>
              <li>Well defined and stringent Standard Operating Procedures</li>
              <li>Customer focused approach</li>
              <li>Uncompromising commitment towards quality</li>
              <li>Experienced and skilled workforce</li>
              <li>On time delivery with quick turnaround time</li>
              <li>Cost effective solutions</li>
              <li>
                World Class facility with highest quality infrastructure and
                instrumentation
              </li>
              <li>Assured data confidentiality and integrity</li>
            </ul>
          </div>
          <div className="whyChooseUs-container-div2">
            <div className="whyChooseUs-container-div-row1">
              <div className="whyChooseUs-container-card">
                <img
                  src={quality}
                  alt="quality_img"
                  className="whyChooseUs-container-card-icon"
                />
                <p>Assured quality</p>
              </div>
              <div className="whyChooseUs-container-card ">
                <img
                  src={expert}
                  alt="expert_img"
                  className="whyChooseUs-container-card-icon "
                />
                <p>Expertise</p>
              </div>
              
            </div>
            <div className="whyChooseUs-container-div-row1">
            <div className="whyChooseUs-container-card">
                <img
                  src={clock}
                  alt="clock_img"
                  className="whyChooseUs-container-card-icon"
                />
                <p>Fast turn around time</p>
              </div>
              <div className="whyChooseUs-container-card">
                <img
                  src={data}
                  alt=""
                  className="whyChooseUs-container-card-icon"
                />
                <p>Data integrity</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}
export default WhyChooseUs;
